import React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";

export const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const { setLanguage } = useAuth();
  const current = i18n.language?.startsWith("en") ? "en" : "es";

  const toggle = (lang) => setLanguage(lang);

  return (
    <div className="inline-flex items-center rounded-full border border-stone-border bg-white p-0.5" data-testid="lang-toggle">
      {["es", "en"].map((lang) => (
        <button
          key={lang}
          data-testid={`lang-${lang}-btn`}
          onClick={() => toggle(lang)}
          className={`px-3 py-1 text-xs font-semibold rounded-full transition-colors ${
            current === lang ? "bg-brand text-white" : "text-stone-sub hover:text-brand"
          }`}
        >
          {lang.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
